import type { Composer } from 'vue-i18n';

export interface ErrorRetryProps {
  title: string;
  description: string;
  retryText: string;
  pageTitle?: string;
}

export const useErrorRetry = (i18n: Composer): ErrorRetryProps => {
  const safeTranslate = (key: string): string => {
    const result = i18n.t(key);
    return typeof result === 'string' ? result : String(result);
  };

  return {
    title: safeTranslate('genericError.title'),
    description: safeTranslate('genericError.description'),
    retryText: safeTranslate('genericError.tryAgain'),
    pageTitle: safeTranslate('genericError.pageTitle'),
  };
};
